export const Strings = {
    //Login Screen
    emailLabel: 'ID / メールアドレス',
    passwordLabel: 'パスワード',
    rememberMe: 'ログイン状態を保持する',
    loginButton: 'ログイン',
    cancelButton: 'キャンセル',
    forgotPassword: 'パスワードを忘れた方',
    emailRequired: 'ID / メールアドレスを入力してください',
    passwordRequired: 'パスワードを入力してください',
    emailFormat: 'メールアドレスの形式が違います。',
    emailOrPasswordIncorrect: 'メールアドレスまたはパスワードが正しくありません。',
    errorNetwork: 'ネットワークに接続されていません。',

    // First time reset password screen
    newPasswordLabel: '正式なパスワードを入力してください',
    confirmNewPasswordLabel: '正式なパスワードを確認',
    newPasswordRequired: '正式なパスワードを入力してください',
    confirmNewPasswordRequired: '正式なパスワードを確認を入力してください',
    passwordStrength: '[入力形式]パスワードは8文字以上大文字あり、半角英数字で入力してください。',
    notAgree: '利用規約に同意してください',
    resetPasswordButton: 'パスワード再設定',
    passwordNotMatch: 'パスワードが一致していません。',
    FirstTimeResetPasswordButton: 'パスワード入力',

    // Forgot Password Screen
    registeredEmailRequired: '登録済みのメールアドレスを入力してください',
    emailNotExist: 'メールアドレスが正しくありません。',
    verificationCodeRequired: '確認コードを入力してください',
    newPasswordRequiredOnForgotPasswordLabel: '新しいパスワードを入力してください',
    newPasswordConfirmLabel: '新しいパスワードを確認',
    newPasswordConfirmRequired: '新しいパスワードを確認を入力してください',
    codeMismatch: '確認コードが違います。',
    resetPasswordComplete: 'パスワードの再設定が完了しました。',
    returnLoginScreen: 'ログイン画面へ戻る',

    // OTP code Screen
    deniedOTP: "ワンタイムパスワードの利用が許可されませんでした。",
    invalidOTP: "ワンタイムパスワードが正しくありません。",
    requiredOTP: 'ワンタイムパスワードが未入力です',
}